import { Autocomplete, TextField, TextFieldVariants } from "@mui/material";
import useGlobalContext from "hooks/globalData";
import { useIntl } from "react-intl";
import { useQuery } from "react-query";
import {
  ListRequestOfBaseFilter,
  SkuStatus,
} from "services/KnowfullyAdminClient";

type SelectSkuStatusMultipleProps = {
  value: string[];
  onChange: (v: string[]) => void;
  variant?: TextFieldVariants;
  disabled?: boolean;
};

const SelectSkuStatusMultiple = ({
  onChange,
  value,
  variant,
  disabled,
}: SelectSkuStatusMultipleProps) => {
  const { skuService } = useGlobalContext();
  const { formatMessage: t } = useIntl();

  const { data, isFetching } = useQuery(
    ["skuService.getSkuStatuses"],
    () =>
      skuService.getSkuStatuses(
        ListRequestOfBaseFilter.fromJS({
          sortField: "displayOrder",
        })
      )
  );

  const handleChangeMultiple = (_: any, values: SkuStatus[]) => {
    onChange(values.map((v) => v.id!));
  };

  const statuses = data?.data ?? [];

  return (
    <Autocomplete
      multiple
      ChipProps={{ size: "small" }}
      options={statuses}
      getOptionLabel={(option) => option.name ?? "?"}
      value={statuses.filter((r) => value.includes(r.id!) ?? false)}
      onChange={handleChangeMultiple}
      loading={isFetching}
      disabled={disabled}
      renderInput={(params) => (
        <TextField
          {...params}
          variant={variant}
          label={t({ id: "skuStatusLabel" })}
        />
      )}
    />
  );
};

export default SelectSkuStatusMultiple;
